import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const CheckCircle2: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['circle', { cx: '12', cy: '12', r: '10' }],
    ['path', { d: 'm9 12 2 2 4-4' }],
  ],
];

export default CheckCircle2;
